import React from 'react';

function GPay(props: object) {
  return (
    <svg
      width="52"
      height="21"
      viewBox="0 0 52 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.2684 9.85771V15.8326H22.3594V1.07812H27.4202C28.7028 1.07812 29.7965 1.50279 30.6913 2.3521C31.606 3.20142 32.0634 4.23838 32.0634 5.46298C32.0634 6.7172 31.606 7.75416 30.6913 8.5936C29.8064 9.43304 28.7127 9.84783 27.4202 9.84783H24.2684V9.85771ZM24.2684 2.89527V8.04056H27.46C28.2156 8.04056 28.8519 7.78379 29.3491 7.28012C29.8561 6.77646 30.1146 6.16416 30.1146 5.47285C30.1146 4.79142 29.8561 4.189 29.3491 3.68534C28.8519 3.16192 28.2255 2.90515 27.46 2.90515H24.2684V2.89527Z"
        fill="#5F6368"
      />
      <path
        d="M37.0555 5.40234C38.4674 5.40234 39.581 5.77762 40.3963 6.52818C41.2116 7.27874 41.6192 8.30583 41.6192 9.60943V15.8312H39.7997V14.4288H39.7202C38.9347 15.5843 37.8808 16.1571 36.5683 16.1571C35.4448 16.1571 34.5102 15.8312 33.7546 15.1695C32.9989 14.5078 32.6211 13.6881 32.6211 12.7006C32.6211 11.6537 33.0188 10.8242 33.8142 10.2119C34.6096 9.58968 35.6735 9.28353 36.9959 9.28353C38.1293 9.28353 39.0639 9.49092 39.7898 9.90571V9.47117C39.7898 8.80949 39.5312 8.25645 39.0043 7.79228C38.4773 7.32812 37.8609 7.10098 37.155 7.10098C36.0911 7.10098 35.246 7.54539 34.6295 8.44409L32.9492 7.39725C33.8739 6.06402 35.246 5.40234 37.0555 5.40234ZM34.5897 12.7302C34.5897 13.224 34.7985 13.6388 35.2261 13.9647C35.6437 14.2906 36.1408 14.4584 36.7075 14.4584C37.5129 14.4584 38.2288 14.1622 38.8551 13.5696C39.4815 12.9771 39.7997 12.2858 39.7997 11.4858C39.2031 11.0217 38.3779 10.7847 37.314 10.7847C36.5385 10.7847 35.8922 10.9723 35.3752 11.3377C34.8483 11.7229 34.5897 12.187 34.5897 12.7302Z"
        fill="#5F6368"
      />
      <path
        d="M51.9973 5.73047L45.634 20.2676H43.6654L46.0317 15.1816L41.8359 5.73047H43.914L46.9365 12.9793H46.9763L49.9193 5.73047H51.9973Z"
        fill="#5F6368"
      />
      <path
        d="M16.6765 8.65363C16.6765 8.03541 16.6209 7.44385 16.5175 6.875H8.51562V10.134L13.124 10.135C12.9371 11.2194 12.3356 12.1437 11.4139 12.76V14.8744H14.1571C15.7588 13.4019 16.6765 11.2253 16.6765 8.65363Z"
        fill="#4285F4"
      />
      <path
        d="M11.4156 12.7594C10.652 13.271 9.66871 13.5702 8.51834 13.5702C6.29616 13.5702 4.41103 12.0829 3.73593 10.0781H0.90625V12.2587C2.30816 15.022 5.18954 16.9181 8.51834 16.9181C10.8191 16.9181 12.7519 16.1666 14.1588 14.8728L11.4156 12.7594Z"
        fill="#34A853"
      />
      <path
        d="M3.46899 8.45937C3.46899 7.89645 3.56344 7.3523 3.73545 6.84073V4.66016H0.905774C0.326117 5.80279 0 7.09256 0 8.45937C0 9.82618 0.327112 11.116 0.905774 12.2586L3.73545 10.078C3.56344 9.56645 3.46899 9.02229 3.46899 8.45937Z"
        fill="#FABB05"
      />
      <path
        d="M8.51834 3.34789C9.7741 3.34789 10.8986 3.77749 11.7865 4.61693L14.2175 2.20428C12.741 0.838455 10.8161 0 8.51834 0C5.19054 0 2.30816 1.89615 0.90625 4.6594L3.73593 6.83997C4.41103 4.83519 6.29616 3.34789 8.51834 3.34789Z"
        fill="#E94235"
      />
    </svg>
  );
}

export default GPay;
